import React from "react";
import { withStyles } from "@material-ui/core/styles";
import styles from "./styles";
import SolutionInfo from "./SolutionInfo";
import { Collapse, IconButton } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import clsx from "clsx";

class RouteSolution extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: true,
    };
  }

  toggleRecommendedPickup = () => {
    this.setState((prevState) => ({
      ...prevState,
      expanded: !prevState.expanded,
    }));
  };

  render() {
    const {
      classes,
      selectedDriverAssignmentId,
      driverAssignments,
      selectedPickupId,
      onDriverSelection,
      onPickupSelection,
    } = this.props;
    const { expanded } = this.state;

    return (
      <>
        <div className={classes.headerStyle}>
          Review Optimized Solution ({driverAssignments.length})
          <IconButton
            aria-expanded={expanded}
            aria-label="show more"
            className={clsx(classes.expandMain, {
              [classes.expandOpen]: expanded,
            })}
            onClick={this.toggleRecommendedPickup}
          >
            <ExpandMoreIcon />
          </IconButton>
        </div>
        <div
          className={`${expanded ? classes.minHeightAssignDriver : ""} ${
            classes.assignedDriver
          } customScroll`}
        >
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            {driverAssignments.length > 0 ? (
              driverAssignments.map((driverAssignment, index) => (
                <SolutionInfo
                  classes={classes}
                  key={index}
                  isSelected={selectedDriverAssignmentId.includes(
                    driverAssignment.driverId
                  )}
                  driverAssignment={driverAssignment}
                  onDriverSelection={onDriverSelection}
                  onPickupSelection={onPickupSelection}
                  selectedPickupId={selectedPickupId}
                />
              ))
            ) : (
              <div className={classes.noData}>No Data Available</div>
            )}
          </Collapse>
        </div>
      </>
    );
  }
}

export default withStyles(styles)(RouteSolution);
